import React from 'react'
import Navbar from '../../Navbar/Navbar'

const AdminContractDetails = () => {
  return (
    <>
    <Navbar />
    
    </>
  )
}

export default AdminContractDetails